import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPaperPlane,
  faUsers,
  faComments,
  faTrashAlt,
  faTimesCircle,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faPaperPlane,
  faUsers,
  faComments,
  faTrashAlt,
  faTimesCircle,
  faSignOutAlt,
);
